/** Shared pane chrome tokens (planning / assist workspace split). */

export const ASSIST_PANE_SHELL_CLASS =
  'flex min-h-0 min-w-0 h-full max-h-full w-full flex-col overflow-hidden rounded-lg border border-[var(--color-border)] bg-[var(--color-surface-bg)]';

export const ASSIST_PANE_HEADER_CLASS =
  'flex h-12 flex-shrink-0 flex-nowrap items-center justify-between gap-2 border-b border-[var(--color-border)] bg-[var(--color-surface-bg)] px-3';

export const ASSIST_PANE_TITLE_CLASS =
  'min-w-0 shrink truncate pr-2 text-lg font-semibold leading-none text-[var(--color-surface-text)]';

export const ASSIST_WORKSPACE_PAGE_CLASS =
  'flex h-[calc(100vh-11rem)] min-h-[420px] flex-col overflow-hidden bg-[var(--color-secondary-bg)]';

export const ASSIST_WORKSPACE_CONTAINER_CLASS =
  'container mx-auto flex min-h-0 flex-1 flex-col overflow-hidden px-2 py-2';

export const ASSIST_FORM_BODY_CLASS =
  'flex min-h-0 flex-1 flex-col gap-4 overflow-y-auto bg-[var(--color-secondary-bg)] p-3';

export const ASSIST_SPLIT_GRID_CLASS =
  'flex min-h-0 flex-1 flex-col gap-3 overflow-hidden lg:grid lg:grid-cols-2 lg:gap-3';
